<script setup lang="ts">
import { AnnuitiesPremium } from "@/entities/premium";
import { LINKS } from "@/constants/links";

defineProps<{
    premium: AnnuitiesPremium;
}>();
</script>

<template>
    <h5 class="results-header">
        Information about {{ premium.company.name }}
    </h5>
    <p class="pb-4">
        {{ premium?.datapoints?.description }}
    </p>
    <h5 class="results-header">
        Next steps:
    </h5>
    <div class="body-text">
        <ul>
            <li>Continue to shop around with other providers.</li>
            <li>
                Visit <a
                    :href="LINKS.MONEY_HELPER_LINK"
                    target="_blank"
                    rel="noopener noreferrer"
                >MoneyHelper</a> if you’re still unsure.
            </li>
            <li>Contact us if you have any questions about your quotes.</li>
            <li>
                Start your application. Your quotes are valid for a limited time.
                Please refer to the quote (key facts) document and terms & conditions
                for more details on how to secure this guaranteed rate.
            </li>
        </ul>
    </div>
</template>
